/**
 * Where this browser stands with push notifications, so the app can say what to do next:
 *
 * - 'unsupported': the browser can't do Web Push at all.
 * - 'add-to-home-screen': an iPhone or iPad in a browser tab; iOS only allows push from the app added to the Home
 *   Screen (iOS 16.4 and later).
 * - 'off', 'on' or 'blocked': it can, and notifications are off, on in this browser, or refused in its settings.
 *
 * @param {object} env what the browser offers: { hasPush, isIos, standalone, permission, subscribed }
 */
export function pushStatus({ hasPush, isIos, standalone, permission, subscribed }) {
  if (isIos && !standalone) {
    return 'add-to-home-screen';
  }
  if (!hasPush) {
    return 'unsupported';
  }
  if (permission === 'denied') {
    return 'blocked';
  }
  return subscribed && permission === 'granted' ? 'on' : 'off';
}

/** What this browser offers, for pushStatus (minus `subscribed`, which needs the service worker). */
export function browserPushEnv() {
  const nav = window.navigator;
  return {
    hasPush: 'serviceWorker' in nav && 'PushManager' in window && 'Notification' in window,
    // iPadOS reports itself as a Mac, so a touch screen gives it away.
    isIos: /iPhone|iPad|iPod/.test(nav.userAgent) || (nav.platform === 'MacIntel' && nav.maxTouchPoints > 1),
    standalone: nav.standalone === true || window.matchMedia('(display-mode: standalone)').matches,
    permission: 'Notification' in window ? window.Notification.permission : 'default',
  };
}

/** The server's base64url public key as the bytes pushManager.subscribe wants. */
export function keyBytes(base64Url) {
  const base64 = (base64Url + '='.repeat((4 - (base64Url.length % 4)) % 4)).replace(/-/g, '+').replace(/_/g, '/');
  return Uint8Array.from(window.atob(base64), char => char.charCodeAt(0));
}
